<template>
  <div class="not-full">
    <AgreementItem class="w-100 mt-16px"
                   :agreement="allagreement"
                   @toggleAll="toggleAll"></AgreementItem>
    <div v-for="(agreement, index) in agreements"
         :key="index"
         class="w-100 mt-16px">
      <AgreementItem :agreement="agreement"></AgreementItem>
    </div>
  </div>
</template>

<script>
import AgreementItem from './AgreementItem'

export default {
  name: 'AgreementList',
  components: {
    AgreementItem
  },
  props: {
    agreements: {
      type: Array,
      default() { return [] }
    },
    terms: {
      type: Array,
      default() { return [] }
    }
  },
  data: function () {
    return {
      allagreement: {
        is_all: true,
        is_agreed: false,
        title: '전체 동의'
      }
    }
  },
  computed: {
    isAgreedAll() {
      return this._.every(this.agreements, 'is_agreed')
    },
  },
  created() {
    this.allagreement.is_agreed = this.isAgreedAll
  },
  destroyed() {},
  methods: {
    toggleAll() {
      if (this.allagreement.is_agreed) {
        this.agreeAll()
      } else {
        this.disagreeAll()
      }
    },
    async agreeAll() {
      for (let i = 0; i < this.agreements.length; i++) {
        this.agreements[i].is_agreed = true
      }
    },
    async disagreeAll() {
      for (let i = 0; i < this.agreements.length; i++) {
        this.agreements[i].is_agreed = false
      }
    },
  },
}
</script>

<style scoped>

</style>
